import type { Aabb } from './aabb.js';

/**
 * Corps dynamique de la simulation : une AABB mobile.
 *
 * Mutable par construction — le tick clone les corps avant de les faire
 * évoluer, ce qui garde `tick()` pur vu de l'extérieur (spec §3).
 */
export interface Body {
  /** Coin haut-gauche, en tuiles. */
  x: number;
  y: number;
  /** Dimensions de la hitbox, en tuiles. */
  w: number;
  h: number;
  /** Vitesse, en tuiles/seconde. */
  vx: number;
  vy: number;
  /** Le corps repose sur une surface solide (mis à jour à chaque tick). */
  onGround: boolean;
}

export function createBody(x: number, y: number, w: number, h: number): Body {
  return { x, y, w, h, vx: 0, vy: 0, onGround: false };
}

export function cloneBody(body: Body): Body {
  return {
    x: body.x,
    y: body.y,
    w: body.w,
    h: body.h,
    vx: body.vx,
    vy: body.vy,
    onGround: body.onGround,
  };
}

export function bodyAabb(body: Body): Aabb {
  return { x: body.x, y: body.y, w: body.w, h: body.h };
}
